// Деньги Bitrix.
//
// Зачем отдельный файл. У сделок сумма и валюта лежат в двух полях (OPPORTUNITY + CURRENCY_ID),
// а money-поля смарт-процессов приходят ОДНОЙ строкой: «515000|RUB» — сумма и валюта через
// вертикальную черту. Ядро отдаёт /bx сырым (Bitrix-совместимость), значит разбирать это
// приходится фронту. Дебиторка — первый потребитель, но не последний: те же money-поля
// у счетов (31), УПД и расходов, поэтому разбор живёт здесь, а не внутри экрана.

import { fmtMoney } from './format'

export interface Money {
  amount: number
  currency: string
}

/** Валюта по умолчанию: в 134 всё в рублях, но полагаться на это в разборе нельзя. */
const DEFAULT_CURRENCY = 'RUB'

/**
 * Число из Bitrix. double-поля приходят строкой, иногда с запятой вместо точки
 * и с пробелами разрядов (если значение вводили руками). Не число → null.
 */
export function toNumber(v: unknown): number | null {
  if (typeof v === 'number') return Number.isFinite(v) ? v : null
  if (typeof v !== 'string') return null
  const s = v.trim().replace(/[\s ]/g, '').replace(',', '.')
  if (!s) return null
  const n = Number(s)
  return Number.isFinite(n) ? n : null
}

/**
 * «515000|RUB» → {amount: 515000, currency: 'RUB'}. Пусто или мусор → null.
 *
 * Почему null, а не {amount: 0}: ноль — это «сумма ноль», а отсутствие поля — «мы не знаем».
 * На экране это разные вещи («0 ₽» против «—»), и в сумме по корзине тоже: неразобранное
 * значение не должно молча превратиться в ноль и уменьшить долг.
 */
export function parseMoney(v: unknown, fallbackCurrency = DEFAULT_CURRENCY): Money | null {
  // множественное money-поле Bitrix отдаёт массивом — берём первое разобравшееся значение
  if (Array.isArray(v)) {
    for (const x of v) {
      const m = parseMoney(x, fallbackCurrency)
      if (m) return m
    }
    return null
  }
  if (typeof v === 'number') return Number.isFinite(v) ? { amount: v, currency: fallbackCurrency } : null
  if (typeof v !== 'string') return null
  const s = v.trim()
  if (!s) return null
  const bar = s.indexOf('|')
  const amount = toNumber(bar === -1 ? s : s.slice(0, bar))
  if (amount === null) return null
  const cur = (bar === -1 ? '' : s.slice(bar + 1)).trim().toUpperCase()
  // код валюты берём только если он похож на код: «515000|» и «515000|мусор» — это рубли
  return { amount, currency: /^[A-Z]{3}$/.test(cur) ? cur : fallbackCurrency }
}

/** Money-поле сразу человеку: «515 000 ₽». Пусто/не разобралось → «—». */
export function fmtMoneyField(v: unknown, fallbackCurrency = DEFAULT_CURRENCY): string {
  const m = parseMoney(v, fallbackCurrency)
  return m ? fmtMoney(m.amount, m.currency) : '—'
}
